module.exports = __webpack_public_path__ + "img/webeditor-2.449b886c.png";